import React, { useCallback } from 'react';
import { analyticsUtils } from 'utils/analytics-utils';

/**
 * elementBlock {string} - Блок, в котором расположен элемент
 * elementName {string} - Название блока
 * elementText {string} - Текст кнопки
 */
export type WithGAButtonClickProps = {
  elementBlock: string;
  elementName: string;
  elementText: string;
  elementVariant?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick?: (e: any) => void;
  href?: string;
};

/**
 * HOC, который добавляет компоненту обработчик события вида "GA:clickButton" при срабатывании события "onClick"
 */
export function withGAClickButton<T extends WithGAButtonClickProps>(WrappedComponent: React.FC<T>) {
  return ({ elementBlock, elementName, elementText, elementVariant, onClick, ...props }: T & WithGAButtonClickProps) => {
    /**
     * Обработчик события onClick с отправкой "GA:clickButton"
     */
    const handleBtnClick = useCallback(
      (e: unknown) => {
        if (onClick) {
          onClick(e);
        }

        analyticsUtils.clickButtonEvent(elementBlock, elementText, elementName, elementVariant);
      },
      [elementBlock, elementName, elementText, elementVariant, onClick]
    );

    /**
     * Обработчик события onAuxClick с отправкой "GA:clickButton"
     */
    const handleWheelClick = useCallback(
      (e: MouseEvent) => {
        // Проверка, что кликнута именно средняя кнопка/колёсико
        if (e.button === 1) {
          analyticsUtils.clickButtonEvent(elementBlock, elementText, elementName, elementVariant);
        }
      },
      [elementBlock, elementName, elementText, elementVariant]
    );

    return props.href ? (
      <WrappedComponent onAuxClick={handleWheelClick} onClick={handleBtnClick} {...(props as T)} />
    ) : (
      <WrappedComponent onClick={handleBtnClick} {...(props as T)} />
    );
  };
}
